import { render, staticRenderFns } from "./Article_1.vue?vue&type=template&id=5da774a9&scoped=true&"
import script from "./Article_1.vue?vue&type=script&lang=js&"
export * from "./Article_1.vue?vue&type=script&lang=js&"
import style0 from "./Article_1.vue?vue&type=style&index=0&id=5da774a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da774a9",
  null
  
)

component.options.__file = "Article_1.vue"
export default component.exports